<section id="dynamic-category-header-2345674" class="dynamic-header-background">
    <div class="header-layout-5">
        <div class="top-section">
            <div class="logo-hamburger-wrapper">
                <!-- Hamburger -->
                @if (isMobile() && headerData.menuListVisibleOnMobile) {
                <img (click)="toggleHamburgerMenu()" class="hamburger-btn" [src]="headerData.hamburgerMenuIcon" />
                }

                <!-- Mobile logo -->
                @if (headerData.logo.isVisibleOnMobile && isMobile()) {
                <a [routerLink]="['/']" class="logo">
                    <img class="static-header-logo" [src]="headerData.logo.logoSrc" />
                </a>
                } @else {
                @if (headerData.logo.isVisibleOnDesktop && isDesktop()) {
                <a [routerLink]="['/']" class="logo">
                    <img class="static-header-logo" [src]="headerData.logo.logoSrc" />
                </a>
                }
                }
            </div>

            <!-- Search bar -->
            @if (!isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
            <base-search-bar class="only-desktop" [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay" />
            }

            <div class="operation-button-container">
                <!-- Search icon -->
                @if (headerData.searchIcon.isVisibleOnDesktop && isDesktop()) {
                <a class="button search-btn" (click)="toggleSearchDropDown()">
                    <img [src]="headerData.searchIcon.searchIconSrc" />
                </a>
                } @else {
                @if (headerData.searchIconMobile.isVisibleOnMobile && isMobile()) {
                <a class="button search-btn" (click)="toggleSearchDropDown()">
                    <img [src]="headerData.searchIcon.searchIconSrc" />
                </a>
                }
                }

                <!-- Account icon -->
                @if (headerData.accountIcon.isVisibleOnMobile && isMobile()) {
                <a (click)="isHamburgerMenu = false; onLinkClick()" class="button" [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                    <img [src]="headerData.accountIcon.accountIconSrc" />
                </a>
                } @else {
                @if (headerData.accountIcon.isVisibleOnDesktop && isDesktop()) {
                <a class="button" [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']">
                    <img [src]="headerData.accountIcon.accountIconSrc" />
                </a>
                }
                }

                <!-- Cart icon -->
                @if (headerData.cartIcon.isVisibleOnMobile && isMobile()) {
                <a (click)="isHamburgerMenu = false" class="button cart-btn" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                    <img [src]="headerData.cartIcon.cartIconSrc" />
                    <span class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                        {{ cart.cart_items.length }}
                    </span>
                </a>
                } @else {
                @if (headerData.cartIcon.isVisibleOnDesktop && isDesktop()) {
                <a class="button cart-btn" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                    <img [src]="headerData.cartIcon.cartIconSrc" />
                    <span class="cart-count dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                        {{ cart.cart_items.length }}
                    </span>
                </a>
                }
                }
            </div>
        </div>

        <!-- Bottom navigation -->
        <div class="bottom-section dynamic-header-background">
            @if (headerData.menuListVisibleOnDesktop) {
            <nav #changeHeaderElement class="navigation-wrapper mega-menu-category">
                <ul class="navigation-list static-nav dynamic-menu-alignment">
                    @for (staticMenu of headerData.menuItems; track staticMenu.id) {
                    @if (staticMenu.text !== 'Category Header') {
                    <li class="static-menu">
                        <a [ngClass]="{
                      'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                      'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                    }" [id]="staticMenu.id" class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" (click)="onLinkClick()" [target]="staticMenu.target" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">
                            {{ staticMenu.text }}
                        </a>

                        @if (staticMenu.subMenu?.length) {
                        <div (mouseenter)="showActiveColor = true; currentMenuId = staticMenu.id" (mouseleave)="removeHoverStyle()" class="submenu-container dynamic-sub-menu-background hide-sub-menu-header">
                            @for (subMenu of staticMenu.subMenu; track subMenu.id) {
                            <ul class="submenu">
                                <li>
                                    <a (click)="onLinkClick()" [target]="subMenu.target" [attr.data-click_action_value]="subMenu['data-click_action_value']" [attr.data-click_action_choice]="subMenu['data-click_action_choice']" [id]="subMenu.id" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                        {{ subMenu.text }}
                                    </a>
                                </li>
                                @if (subMenu.subMenu?.length) {
                                @for (subSubMenu of subMenu.subMenu; track subSubMenu.id) {
                                <li>
                                    <a [target]="subSubMenu.target" (click)="onLinkClick()" [attr.data-click_action_value]="subSubMenu['data-click_action_value']" [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']" [id]="subSubMenu.id" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                        {{ subSubMenu.text }}
                                    </a>
                                </li>
                                }
                                }
                            </ul>
                            }
                        </div>
                        }
                    </li>
                    }
                    }

                    <div class="dynamic-header" #dynamicCategoryHeader>
                        @if (dynamicHeaderInline() && layoutType === 'inlineLayout1') {
                        @for (parentCategory of category; track parentCategory.id) {
                        <li>
                            <a (click)="filterProductsByCategory(parentCategory?.url_path || ''); onLinkClick()" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu" [ngClass]="{
                        'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                        'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                      }">
                                {{ parentCategory.name }}
                            </a>

                            @if (parentCategory.sub_categories.length) {
                            <div (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()" class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                                @for (childCategory of parentCategory.sub_categories; track childCategory.id) {
                                <ul class="submenu">
                                    <li>
                                        <a (click)="filterProductsByCategory(childCategory?.url_path || ''); onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                            {{ childCategory.name }}
                                        </a>
                                    </li>
                                    @if (childCategory.sub_categories.length) {
                                    @for (subCategory of childCategory.sub_categories; track subCategory.id) {
                                    <li>
                                        <a (click)="filterProductsByCategory(subCategory?.url_path || ''); onLinkClick()" class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                            {{ subCategory.name }}
                                        </a>
                                    </li>
                                    }
                                    }
                                </ul>
                                }
                            </div>
                            }
                        </li>
                        }
                        }
                        @if (dynamicHeaderHover() && layoutType === 'hoverLayout1') {
                        <li>
                            <a (click)="onLinkClick()" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu">
                                {{ headerData.categoryMenuName }}
                            </a>
                            @if (category) {
                            <div class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                                @for (parentCategory of category; track parentCategory.id) {
                                <ul class="submenu">
                                    <li>
                                        <a [ngClass]="{
                                'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                                'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                              }" (click)="filterProductsByCategory(parentCategory?.url_path || ''); onLinkClick()" class="title dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                            {{ parentCategory.name }}
                                        </a>
                                    </li>
                                    @if (parentCategory.sub_categories.length) {
                                    @for (list of parentCategory.sub_categories; track list.id) {
                                    <li (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()">
                                        <a class="dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu" (click)="filterProductsByCategory(list?.url_path || ''); onLinkClick()">
                                            {{ list.name }}
                                        </a>
                                    </li>
                                    }
                                    }
                                </ul>
                                }
                            </div>
                            }
                        </li>
                        }
                    </div>
                </ul>
            </nav>
            }
        </div>

        <!-- Search overlay -->
        @if (isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
        <div class="search-drop-down-container" (click)="toggleSearchDropDown()">
            <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
                <h5 class="dynamic-header-text-color">Start your amazing search :</h5>

                <button class="close-btn" (click)="toggleSearchDropDown()">
                    <img src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png" />
                </button>

                <base-search-bar [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay" />
            </div>
        </div>
        }

        <!-- Mobile side menu -->
        @if (isHamburgerMenu && isMobile() && headerData.menuListVisibleOnMobile) {
        <div appClickOutside #changeHeaderMobileElement class="hamburger-menu-container" (click)="toggleHamburgerMenu()">
            <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
                <static-menu-collapse [headerData]="headerData" (hideMenu$)="toggleHamburgerMenu()" />
                @if (
                (dynamicHeaderInline() && layoutType === 'inlineLayout1') ||
                (dynamicHeaderHover() && layoutType === 'hoverLayout1')
                ) {
                <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category || []" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleHamburgerMenu()" />
                }
            </div>
        </div>
        }
    </div>
</section>